// utils/timeChangeHelper.js

// Parse "2026-02-03 11:00 AM" safely (Safari compatible)
export const parseLocalDateTime = (startStr) => {
  if (!startStr) return null;

  const parts = startStr.trim().split(" ");
  if (parts.length < 3) return null;

  const [datePart, timePart, ampm] = parts;
  const [year, month, day] = datePart.split("-").map(Number);
  let [hour, minute] = timePart.split(":").map(Number);

  if (!year || !month || !day || hour === undefined || minute === undefined) {
    return null;
  }

  const isPM = ampm.toLowerCase() === "pm";

  if (isPM && hour < 12) hour += 12;
  if (!isPM && hour === 12) hour = 0;

  const date = new Date(year, month - 1, day, hour, minute);

  return isNaN(date) ? null : date;
};

// Format date label
export const formatDateLabel = (date, locale = "en-NZ") => {
  if (!date) return "---";

  return date.toLocaleDateString(locale, {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

// Format time label
export const formatTimeLabel = (date, locale = "en-NZ") => {
  if (!date) return "---";

  return date.toLocaleTimeString(locale, {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

// Format full appointment range
export const formatAppointmentRange = (startStr, totalMins) => {
  const start = parseLocalDateTime(startStr);
  if (!start) return { date: "---", time: "---" };

  const end = new Date(start.getTime() + totalMins * 60000);

  return {
    date: formatDateLabel(start),
    time: `${formatTimeLabel(start)} – ${formatTimeLabel(end)}`,
  };
};

// Check if booking is past
export const isPastBooking = (startStr) => {
  const date = parseLocalDateTime(startStr);
  if (!date) return false;

  return date < new Date();
};
